import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { NewNodalOfficerDashboardModel } from "src/app/model/NewNodalOfficerDashboardModel";
import { DashboardService } from "src/app/services/dashboard.service";
import { IgxLegendComponent, IgxCategoryChartComponent } from 'igniteui-angular-charts';
import { ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PendencyDashboardModel } from "src/app/model/PendencyDashboardModel";
import { forkJoin } from "rxjs/internal/observable/forkJoin";
import { ApplicationsListResponseModel } from "src/app/model/ApplicationsListResponseModel";
import { MatDialog } from "@angular/material/dialog";
import { ExcelExportService } from "src/app/services/excel-export.service";
import { MasterService } from "src/app/services/master.service";



@Component({
  selector: "pendency-dashboard",
  templateUrl: "./pendency-dashboard.component.html",
  styleUrls: ["./pendency-dashboard.component.scss"],
})

export class PendencyDashboarComponent implements OnInit {
   
  userName: string;

  constructor(public dialog: MatDialog,
    private masterService: MasterService,
    private excelExportService: ExcelExportService,
    private router: Router, private dashboardService: DashboardService, 
    private modalCtrl: ModalController
    ) {}
  
  pendencyDashboardModel: PendencyDashboardModel;
  loaded: boolean = false;
  date: Date;
  nocPendingCount:number;
  @ViewChild("legend", { static: true } )
  private legend: IgxLegendComponent
  @ViewChild("chart", { static: true } )
  private chart: IgxCategoryChartComponent
  pendencyDetails: any[] = [];
 

  allAvaiableWltLstCount : number;
  lotetryFilter: FormGroup = new FormGroup({});
  lotteries: {[key: number]: string};
  filterForm: FormGroup = new FormGroup({});
  form: FormGroup = new FormGroup({});
  chartOptions;
  displayedColumns: string[] = [
    "key",
    "lottery",
    "actionTime",
    "status",
  ];

  allPageDataAllWltType: ApplicationsListResponseModel [] = [];
    
  ngOnInit(): void { 
    
    this.filterForm = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
      ]),
      lotetryFilter: new FormControl()
     
    });
    this.loadData();
    
  }

  refresh() {
    this.ngOnInit();
  }
  loadData() {
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
    this.loaded = false;
    this.date = null;
    
      console.log(roles,"from rolls");
      this.dashboardService.fetctPendancyCountDashboard().subscribe((dashboard: any) => { 
        console.log("dashboard >> ", dashboard);   
        this.pendencyDetails=dashboard;       
        this.loaded = true;
    
      });
  }

  exportOperatingData(){
    forkJoin([
      this.masterService.fetchApplicantsList(0, 50000, null, 'APPLICANT SURRENDERED TENEMENT', null, null, null),
      this.masterService.fetchApplicantsList(0, 50000, null, 'ACCEPTANCE PENDING', null, null, null),
      this.masterService.fetchApplicantsList(0, 50000, null, 'INELIGIBLE IN POST LOTTERY', null, null, null)
    ]).subscribe(([page1, page2, page3]) => {
      this.allPageDataAllWltType = [
        ...page1.applicationResponceWrapper.content,
        ...page2.applicationResponceWrapper.content,
        ...page3.applicationResponceWrapper.content
      ];
  
      console.log("All page data:", this.allPageDataAllWltType);
  
      if (this.allPageDataAllWltType.length > 0) {
        console.log("this.allPageDataAllWltType.length >> ",this.allPageDataAllWltType.length);
        this.allAvaiableWltLstCount = this.allPageDataAllWltType.length;
        console.log("this.allAvaiableWltLstCount >> ",this.allAvaiableWltLstCount);
      }
    }, error => {
      console.error("Error:", error);
    });
  }

  allPageDataAllWltTypeClmnName(arg0: string, allPageDataAllWltTypeClmnName: any, lst: { [key: string]: string; }[], allPageDataAllWltTypeClmnWdth: any, arg4: string, arg5: string) {
    throw new Error("Method not implemented.");
  }
  allPageDataAllWltTypeClmnWdth(arg0: string, allPageDataAllWltTypeClmnName: any, lst: { [key: string]: string; }[], allPageDataAllWltTypeClmnWdth: any, arg4: string, arg5: string) {
    throw new Error("Method not implemented.");
  }


  
  
 

 
}